import React from 'react';
import { CompanyPhoneNumber } from '../../utils/Constants';

function ImageBannerCta() {
  return (
    <section className='grid w-full'>
      <div className='grid w-full bg-colour5 dark:bg-colour5 py-6'>
        <div className='grid w-full bg-banner bg-cover bg-center py-24'>
          <section className='text-center'>
            <div className='gid gap-1 p-1 font-StencilW01 text-4xl text-colour5 dark:text-colour5 bg-colour2/40 dark:bg-colour1/40 w-fit mx-auto'>
              <div>
                <span>CALL</span>
              </div>
              <a href={CompanyPhoneNumber}>{CompanyPhoneNumber}</a>
            </div>
          </section>
        </div>
      </div>
    </section>
  );
}

export default ImageBannerCta;
